import React, { useState, useEffect } from 'react';
import { Header } from '../../components/header/Header';
import { signIn, getUserById } from '../../utils/botFactoryAPI'; 

import './AdminPage.scss';

const bots = [
    {
      title: 'NOVA',
      subtitle: 'Cloud Media Works',
      image:
        '/org/cmw/nova/nova-hal-blue-transparent.gif',
      url: '/signin?id=asst_KRNWqGjeXzplxMbQgRoXJ3G7',
    },
    {
      title: 'ASK JOE',
      subtitle: "Trader Joe's Shopping Assistant",
      image: 'https://www.traderjoes.com/content/dam/trjo/pictures/logo.svg',
      url: 'signin?id=asst_XPNDfJ387Uz8E4rcYq0E79Qy',
    },
    {
      title: 'Harper',
      subtitle: 'Beverage Manufacturing',
      image:
        '/org/cmw/ltd/logomobile4.png',
      url: '/signin?id=asst_aQzanaEeGkqMiq7M3Z7Svf6Y',
    },
    {
      title: 'Agent Benjamin Hardy',
      subtitle: 'Master Scaling Coach',
      image:
        'favicon.png',
      url: '/signin?id=asst_flPifeNO0P1IBTxtUyMP83BN',
    },
    {
      title: 'Agent Steve Carillo',
      subtitle: 'Financial Planner',
      image:
        'favicon.png',
      url: '/signin?id=asst_GFCNB9hWZvquM36gHYu12cdq',
    },
    {
      title: 'Jingle Bot',
      subtitle: 'Create Your Song',
      image:
        '/assets/org/carat/sora-mutf8tav.webp',
      url: '/signin?id=asst_RVOwZb5CDbjHbvIamdyMMRik',
    },
    {
      title: 'Stewart',
      subtitle: 'Business Park Representative',
      image:
        '/org/cmw/riverislands/riverislands-logo.png',
      url: '/signin?id=asst_SRqG7nOQ8boguG6EeEPkpNlE',
    },
    {
      title: 'Stewart Clone',
      subtitle: 'Business Park Representative',
      image:
        '/org/cmw/riverislands/riverislands-logo.png',
      url: '/signin?id=asst_k6gkeaM6VZsbvOjfBNt6BFrK',
    },
        {
      title: 'Ms. Woods',
      subtitle: 'River Islands Academies',
      image:
        'https://www.riacademies.net/sysimages/Logo_RIA_black.jpg',
      url: '/signin?id=asst_LaKCs3TTtYdMDI8AAHkFwrKj',
    },
    {
        title: 'Rex',
        subtitle: 'It All Here',
        image:
          'https://www.riacademies.net/sysimages/Logo_RIA_black.jpg',
        url: '/signin?id=asst_UCgfaFOPbRqW395K66FkRVZe',
      }
];

export function AdminPage() {
    const [modalOpen, setModalOpen] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [signInError, setSignInError] = useState<string | null>(null);
  
    const logoPicWhite = "/RobotFactory.png"; // Use a static image

    const handleSignIn = async () => {
      setSignInError(null);
      try {
        // Step 1: sign in to get userId and token
        const signInResponse = await signIn(email, password);
  
        const userId = signInResponse?.userId || signInResponse?.id; // fallback in case different naming
        const token = signInResponse?.token;
  
        if (!userId || !token) {
          setSignInError('Invalid sign in response');
          return;
        }
  
        // Step 2: fetch full user details using userId and token
        const userDetails = await getUserById(userId, token);
  
        // Step 3: Check if userDetails.role includes 'admin'
        if (!userDetails?.role || !userDetails.role.includes('admin')) {
          alert('Admin rights required');
          window.location.href = '/signin';
          return;
        }
  
        // Step 4: Admin verified, close modal
        setModalOpen(false);
  
      } catch (error: any) {
        console.error("SignIn error caught:", error);
        setSignInError(error.message || "Sign In failed");
      }
    };
   useEffect(() => {
      //Clear localstore
      localStorage.removeItem("user");
      localStorage.removeItem("org");
      localStorage.removeItem("lastBotId");
      localStorage.removeItem("botId");
      
      
    const timer = setTimeout(() => {

            //Set the logo for Admin Page
            const title = document.querySelector('title');
            if (title) {
              title.setAttribute('innerText', "Admin Console");
      
            } else {
              console.error('title element not found');
            }

        //Set the logo for Admin Page
        const logo = document.querySelector('.header-logo');
        if (logo) {
          logo.setAttribute('src', logoPicWhite);
          logo.setAttribute('alt', 'Admin Logo');
        } else {
          console.error('Logo element not found');
        }
      }, 100); // delay to wait for DOM

    }, []);

  return (
    <>
      <Header />

      {modalOpen && (
        <div className="modal-overlay" style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          justifyContent: 'center', alignItems: 'center', zIndex: 1000,
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white', padding: '2rem', borderRadius: '8px',
            width: '320px', boxShadow: '0 2px 10px rgba(0,0,0,0.3)'
          }}>
            <h2>Admin Sign In</h2>
            <div>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: '100%', marginBottom: '1rem', padding: '0.5rem' }}
                autoComplete="username"
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ width: '100%', marginBottom: '1rem', padding: '0.5rem' }}
                autoComplete="current-password"
              />
              {signInError && (
                <div style={{ color: 'red', marginBottom: '1rem' }}>{signInError}</div>
              )}
              <button
                onClick={handleSignIn}
                style={{ width: '100%', padding: '0.5rem' }}
              >
                Sign In
              </button>
            </div>
          </div>
        </div>
      )}

      {!modalOpen && (
        <div id="admin-root" className="admin-root">
          <div className="admin" style={{width:'90vw', position:'absolute', top:'7vh' }}>
            <h2 className="title">ADMIN</h2>
            <hr />
            <h3 className="subtitle">Control Room</h3>
            <p className="edition">Build a Bot</p>
          </div>
          <div className="admin-container">
            <div className="admin-cards">
              {bots.map((bot, index) => (
                <a
                  key={index}
                  href={bot.url}
                  className="admin-card"
                  target="_self"
                >
                  <div className="admin-card-content">
                    <img src={bot.image} alt={bot.title} className="admin-card-image" />
                    <h3 className="admin-card-title">{bot.title}</h3>
                    <p className="admin-card-subtitle">{bot.subtitle}</p>
                    <button className="admin-card-button">Open</button>
                  </div>
                </a>
              ))}
            </div>
          </div>
          <div className="foot-container">
            <br />
            <p className="foot" style={{color:'white', height:'50px'}}>&copy; 2025 Cloud Media Works, LLC - All Rights Reserved</p>
            <br />
          </div>
        </div>
      )}
    </>
  );
}

export default AdminPage;
